module.exports = __webpack_public_path__ + "static/media/Nguyen_Anh_Duy.50fb7856.jpeg";